
	
	// external js: flickity.pkgd.js

Flickity.prototype.getSelectedCellIndexes = function() {
  return this.selectedCells.map( function( cell ) {
    return this.cells.indexOf( cell );
  }, this );
};

var flkty = new Flickity( '.carousel', {

  freeScroll: true,
  wrapAround: true
});


// external js: flickity.pkgd.js

Flickity.prototype.getSelectedCellIndexes = function() {
  return this.selectedCells.map( function( cell ) {
    return this.cells.indexOf( cell );
  }, this );
};

var flktys = new Flickity( '.carousels', {
  freeScroll: true,
  groupCells: true,
  wrapAround: true
});

// external js: flickity.pkgd.js

Flickity.prototype.getSelectedCellIndexes = function() {
  return this.selectedCells.map( function( cell ) {
    return this.cells.indexOf( cell );
  }, this );
};

var flktysresultslider = new Flickity( '.carousel-result', {
  freeScroll: true,
  wrapAround: true,
});



// $(document).ready(function(){
// 	$(".tabs").hide();
// 	$("#Ingredients").hide();
// 	$("#tab-1").addClass("active");

//     $("#tab-1").click(function(){
//     $(".tabs").hide();
//     $("#Ingredients").show();
//     $("#tab-1").addClass("active");
//     $("#tab-2").removeClass("active");
//     $("#tab-3").removeClass("active");
//     });

//     $("#tab-2").click(function(){
//     $(".tabs").hide();
//     $("#Tab2").show();
//     $("#tab-2").addClass("active");
//     $("#tab-1").removeClass("active");
//     $("#tab-3").removeClass("active");
//     });

//     $("#tab-3").click(function(){
//     $(".tabs").hide();
//     $("#Tab3").show();
//     $("#tab-3").addClass("active");
//     $("#tab-1").removeClass("active");
//     $("#tab-2").removeClass("active");
//     });
//    });


// function myFunction() {
//   var dots = document.getElementById("read-more");
//   var btnText = document.getElementById("#myBtn");

//   if (dots.style.display === "none") {
//     dots.style.display = "inline";
//     btnText.innerHTML = "Read Less"; 
//   } else {
//     dots.style.display = "none";
//     btnText.innerHTML = "Read More"; 
//   }
// }
$('.tab').click(function() {
     var target = $(this.rel);

  $('#tabs_container li').not($(this).parent()).removeClass('tabActive');

  $(this).parent().toggleClass('tabActive');

  $('#tabs_container > .tab_contents_container > div').not($(target)).removeClass('tab_contents_active'); 
  $(target).toggleClass('tab_contents_active');
 })

$('.tabs a').removeAttr('href');

$( "#tabs_container" ).appendTo( ".product__information" );

